const AuditLog = () => {
  return (
    <div className="bg-white rounded-xl p-6 shadow-md">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Audit Log</h2>
      <p className="text-gray-600">Audit log viewer coming soon...</p>
    </div>
  )
}

export default AuditLog
